// extracted by mini-css-extract-plugin
module.exports = {"main":"list_main__1Zq4N","atv":"list_atv__8Tcks","name":"list_name__5lnpT","nameDiv":"list_nameDiv__CmZLB","loopRun":"list_loopRun__VZsmL","tag":"list_tag__I6Quc"};